import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Stack
} from "@mui/material";
import { createClient } from '@supabase/supabase-js';
import React, { useCallback, type FC, useState } from "react";
import { FileDropzone } from "../files";
import toast from "react-hot-toast";

export interface Values {
  barcode: string;
  productId: string;
  category: string;
  description: string;
  images: string;
  name: string;
  price: number;
  unit: string;
  sku: string;
  submit: null;
}


interface Props {
  state: boolean;
  setState: any;
  files: File[];
  setFiles: any;
  imageState: any
  multiple?: boolean
}

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  borderRadius: "10px"
};

export const ImageUpload: FC<Props> = (props) => {
  const URL = process.env.NEXT_PUBLIC_SUPABASE_URL || ''
  const KEY = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || ''
  const supabase = createClient(URL, KEY);
  const { state, setState, files, setFiles, imageState } = props
  const [loader, setLoader] = useState(false)

  const handleClose = useCallback(() => {
    setFiles([])
    setState(false)
  }, [])



  const uploadFile = useCallback(async () => {
    setLoader(true)

    const file: any = files[0];
    if (!file) {
      setLoader(false)
      return
    }
    // Call Storage API to upload file
    const { data, error } = await supabase.storage
      .from('Zolo')
      .upload(file.name, file);


    // Handle error if upload failed
    if (error) {
      setLoader(false)
      toast.error('Error uploading file.');
      return;
    }

    // setFiles(data.path)
    handleClose();
    imageState(data.path)
    setLoader(false)
    toast.success('File uploaded successfully!');
  }, [files])

  const handleFilesDrop = useCallback((newFiles: File[]): void => {
    setFiles((prevFiles: File[]) => {
      return [...prevFiles, ...newFiles];
    });
  }, []);

  const handleFileRemove = useCallback((file: File): void => {
    setFiles((prevFiles: File[]) => {
      // @ts-ignore
      return prevFiles.filter((_file) => _file.path !== file.path);
    });
  }, []);

  const handleFilesRemoveAll = useCallback((): void => {
    setFiles([]);
  }, []);

  return <Modal
    open={state}
    onClose={handleClose}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
    sx={{ border: "none" }}
  >
    <Box sx={style}>
      <FileDropzone
        imageUploader
        accept={{ "image/*": [] }}
        caption="(SVG, JPG, PNG, or gif maximum 900x400)"
        files={files}
        onDrop={handleFilesDrop}
        onRemove={handleFileRemove}
        onRemoveAll={handleFilesRemoveAll}
        multiple={props.multiple ?? true}
      />
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="flex-end"
        sx={{ py: 2 }}
      >
        <Stack
          alignItems="center"
          direction="row"
          spacing={2}
        >
          <Button
            color="inherit"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            onClick={uploadFile}
            type="submit"
            variant="contained"
          >
            {loader ? <CircularProgress color="inherit" size={20} /> : <>Upload</>}
          </Button>
        </Stack>
      </Stack>
    </Box>
  </Modal>
}